export default {
  searchAgainHere: '22022019-142905-0006'
};
